import { render, staticRenderFns } from "./WePayYourRent.vue?vue&type=template&id=8d112314&scoped=true&"
import script from "./WePayYourRent.vue?vue&type=script&lang=ts&"
export * from "./WePayYourRent.vue?vue&type=script&lang=ts&"
import style0 from "./WePayYourRent.vue?vue&type=style&index=0&id=8d112314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d112314",
  null
  
)

export default component.exports